import { createBrowserHistory } from 'history';

import getSearchUrl from '../actions/getSearchUrl';

export default function setSearchUrl ( param, value, deleteParam ) {
	return dispatch => {

		var url = window.location.search;
		var query = new URLSearchParams( url );

		/**
		 * ZOWEL TOEVOEGEN AAN URL ALS VERWIJDEREN DIENT IN 1 KEER TE GEBEUREN
		 * Zowel params als values kunnen uit meerdere items bestaan
		 */

		/**
		 * Check for parameters to delete in URL
		 */

		if ( deleteParam ) {
			if ( deleteParam.includes( ',' ) ) {

				let trimDeleteParams = deleteParam.replace( /\s+/g, '' );
				let deleteParams = trimDeleteParams.split( ',' )

				for ( let parameter of deleteParams ) {
					if ( query.get( parameter ) ) {
						query.delete( parameter )
					}
				}
			} else {
				console.log("deleteParam")
				query.delete( deleteParam )
			}
		}

		/**
		 * Check for parameters to add/edit in URL
		 */

		/**
		* Controleren of de parameter reeds bestaat met dezelfde waarde, dan dient deze verwijderd te worden
		*/

		if ( null !== param && null !== value ) {

			let params = param.split( ',' )
			let values = value.split( ',' )

			if ( params.length === values.length ) {
				/**
				 * Checken of er meerdere parameters zijn zoals bv. topthema en thema
				 * Er zijn meerdere parameters en meerdere values
				 */
				for ( let i = 0; i < params.length; i++ ) {

					if ( query.get( params[ i ] ) && query[ params[ i ] ] === values[ i ] ) {
						query.delete( params[ i ] )
					} else {
						query.set( params[ i ], values[ i ] )
					}
				}
			} else if ( values.length > params.length ) {
				/**
				 * Er is slechts 1 parameter en meerdere values zoals bij regions
				 */
				if ( query.get( params ) && query[ params ] === values ) {
					query.delete( params )
				} else {
					query.set( params, values )
				}
			} else {
				/**
				 * Er is slechts 1 parameter en 1 value zoals bij query, locatie
				 */
				if ( query.get( param ) && query[ param ] === value ) {
					query.delete( param )
				} else {
					query.set( param, value )
				}
			}
		}

		/**
		 * Zet search URL.
		 */

		let history = createBrowserHistory();
		let searchParams = query.toString();

		if('' !== searchParams){

		history.push( {
			pathname: '',
			search: '?' + searchParams
		} );
	}else{
		history.replace('/knowledge/')
	}

		dispatch( getSearchUrl() );
	}
}